import type { RevealedSong } from "@hitster/shared";
import type { PlayerColor } from "../lib/playerColors";

interface Props {
  song: RevealedSong;
  compact?: boolean;
  playerColor?: PlayerColor;
}

export function TimelineCard({ song, compact, playerColor }: Props) {
  const label = `${song.title} par ${song.artist}, ${song.releaseYear}`;

  const mobileStyle = playerColor
    ? { backgroundColor: playerColor.cardBackground, borderColor: playerColor.cardBorder }
    : undefined;

  const desktopStyle = playerColor
    ? {
        background: `linear-gradient(to bottom right, ${playerColor.cardGradientFrom}, ${playerColor.cardGradientTo})`,
        borderColor: playerColor.cardBorder,
      }
    : undefined;

  const coverStyle = playerColor ? { backgroundColor: `${playerColor.cardBackground}` } : undefined;

  return (
    <>
      {/* Mobile : chip compact (titre / artiste / année uniquement) */}
      <article
        className="sm:hidden flex-shrink-0 w-[5.75rem] rounded-md border px-1.5 py-1"
        style={mobileStyle ?? { borderColor: "rgba(139, 92, 246, 0.35)", backgroundColor: "rgba(46, 16, 71, 0.7)" }}
        aria-label={label}
      >
        <p className="text-orange-400 font-bold text-[11px] leading-none tabular-nums">{song.releaseYear}</p>
        <p className="font-semibold text-[10px] leading-tight truncate mt-0.5">{song.title}</p>
        <p className="text-[9px] text-violet-300/65 leading-tight truncate">{song.artist}</p>
      </article>

      {/* Desktop / tablette : carte avec pochette */}
      <article
        className={`hidden sm:block flex-shrink-0 rounded-xl border overflow-hidden shadow-lg ${compact ? "w-28" : "w-36"}`}
        style={
          desktopStyle ?? {
            borderColor: "rgba(139, 92, 246, 0.4)",
            background: "linear-gradient(to bottom right, rgba(76, 29, 149, 0.4), rgba(30, 58, 138, 0.3))",
          }
        }
        aria-label={label}
      >
        <div
          className={`flex items-center justify-center ${compact ? "h-16" : "h-24"}`}
          style={coverStyle ?? { backgroundColor: "rgba(91, 33, 182, 0.3)" }}
        >
          {song.coverImageUrl ? (
            <img src={song.coverImageUrl} alt="" className="w-full h-full object-cover" />
          ) : (
            <div className="w-12 h-12 rounded-full border-4 border-violet-400/50 vinyl-spin" />
          )}
        </div>
        <div className="p-2">
          <p className="font-semibold text-xs truncate">{song.title}</p>
          <p className="text-[10px] text-violet-300/70 truncate">{song.artist}</p>
          <p className="text-orange-400 font-bold text-sm mt-1">{song.releaseYear}</p>
        </div>
      </article>
    </>
  );
}
